import React, { Children } from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '🤔',
  text: 'Te sientes hinchada después de cada comida'
}, {
  emoji: '😔',
  text: 'Tu ropa ajusta diferente cada día sin razón'
}, {
  emoji: '😩',
  text: 'Esa sensación de pesadez que no desaparece'
}, {
  emoji: '😤',
  text: 'Ya probaste de todo y nada funciona'
}, {
  emoji: '😰',
  text: 'Te despiertas cansada aunque dormiste bien'
}, {
  emoji: '🌀',
  text: 'Sientes tu abdomen tenso e incómodo'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function PainSection() {
  return <section className="bg-wellness-light-sage py-20 px-6" id="pain-points" data-id="element-123">
      <div className="max-w-6xl mx-auto" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-125">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-wellness-dark mb-4" data-id="element-126">
            ¿Te suena familiar?
          </h2>
          <p className="text-lg text-wellness-dark/70 max-w-2xl mx-auto" data-id="element-127">
            Muchas mujeres viven con estas molestias sin saber que pueden
            mejorar con cambios simples.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-128">
          {painPoints.map((point, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-2xl p-6 shadow-sm flex items-center gap-4" data-id="element-129">
              <div className="text-4xl" data-id="element-130">{point.emoji}</div>
              <p className="text-wellness-dark font-medium" data-id="element-131">{point.text}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}